import {RenderingServices, utils} from '@wallaby-ui/core';
import {defineMessages} from 'react-intl';

export const I18N = defineMessages({
  OPEN_DETAIL: {
    id: 'common.link.openDetail',
    defaultMessage: 'Open detail',
    description: 'title text for detail link',
  },
});

const STATIC_EMPTY_OBJECT = {};

export default function baseLinkFormatterParams(
  params,
  services: RenderingServices = {}
) {
  const {intl} = services;
  const {
    searchParams = STATIC_EMPTY_OBJECT,
    data,
    routeParamId = null,
    text,
    useValue = false,
    value,
  } = params;
  let titleText;
  let translatedValue;

  const newSearchParams = {...searchParams};
  const rowData = data;
  if (rowData && rowData.caseId) {
    newSearchParams.caseId = rowData.caseId;
  }
  const linkId =
    useValue || !rowData
      ? value
      : routeParamId || rowData.caseId || rowData.caseid || rowData.id;
  if (value) {
    const linkText = text || value;
    if (intl) {
      translatedValue = utils.TranslateUtils.translate(linkText, intl);
      titleText = `${utils.TranslateUtils.translate(
        I18N.OPEN_DETAIL,
        intl
      )} - ${translatedValue}`;
    }
  }

  return {...params, linkId, titleText, newSearchParams, translatedValue};
}
